import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { ApiService } from '../../services/api.service';
import { CommunityService } from '../../services/community/community.service';
import { CommunityModuleDTO } from '../../DTO/CommunityModuleDTO';

@Component({
  selector: 'app-prior-appointment-legacy-redirect',
  template: '',
})
export class PriorAppointmentLegacyRedirectComponent implements OnInit {
  constructor(
    private readonly actRoute: ActivatedRoute,
    private readonly router: Router,
    private readonly api: ApiService,
    private readonly communityService: CommunityService,
  ) {}

  async ngOnInit(): Promise<void> {
    const queryParams = this.actRoute.snapshot.queryParams;

    try {
      const community = await firstValueFrom(this.communityService.Get());
      if (!community?.id || !community?.code) {
        await this.router.navigateByUrl('/error');
        return;
      }

      // `/modules` omits submodules; legacy URLs still need to resolve when reserves is nested under a parent.
      const modules = await firstValueFrom(this.api.GetAllModules(community.id));
      const moduleId = this.resolveFirstPriorAppointmentModuleId(modules);
      if (moduleId == null) {
        await this.router.navigateByUrl('/error');
        return;
      }

      await this.router.navigate(
        [community.code, 'prior-appointment', 'm', moduleId],
        { queryParams, replaceUrl: true },
      );
    } catch {
      await this.router.navigateByUrl('/error');
    }
  }

  private resolveFirstPriorAppointmentModuleId(modules: CommunityModuleDTO[] | null | undefined): number | null {
    const list = modules ?? [];
    const m = list.find((x) => x?.moduleTypeKey === 'PRIORAPPOINTMENT' || x?.moduleTypeKey === 'RESERVATIONS');
    const id = m?.id;
    return typeof id === 'number' && Number.isFinite(id) ? id : null;
  }
}

